'use client'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import cl from 'clsx'
import { GoArrowUpRight } from "react-icons/go";
import styles from './style.module.css'

const AccordionItem = ({number, title, text, text2, isOpen, onClick, type, shouldScroll = false }) => {
    const contentHeight = useRef()
    const itemRef = useRef()
    const [, forceUpdate] = useState(false)
    useLayoutEffect(() => { forceUpdate(true) }, [])

    useEffect(() => {
        if (isOpen && shouldScroll) {
            const timer = setTimeout(() => {
                itemRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [isOpen, shouldScroll]);
    return (
        <div 
            className={styles.wrapper}
            ref={itemRef}
        >
            <button
                onClick={onClick}
                className={cl(
                    styles.title__container,
                    isOpen ? styles.active : ''
                )}
            >   
                <div className={styles.title__wrapper}>
                <div className={styles.title__number}>/ 0{number}</div>
                <div className={cl(
                            styles.title,
                            'custom-underline'
                            )}>{title}</div>
                </div>
                <GoArrowUpRight className={cl(
                                    styles.arrow,
                                    isOpen ? styles.active : ''
                                )} />
            </button>

            <div
                ref={contentHeight}
                className={styles.text_container}
                style={
                    isOpen
                        ? { height: (contentHeight.current?.scrollHeight ?? 0) + 20 }
                        : { height: '0px' }
                }
            >
                <div className={cl(
                        styles.text__content,
                        type ==='results' && styles.text__content_results
                    )}
                >
                    {text}
                    <br />
                    <div className={styles.text__content_two}>{text2 && text2}</div> 
                </div>
            </div>
        </div>
    )
}

export default AccordionItem
